import {EditorThemeClasses} from "lexical"

export const theme: EditorThemeClasses = {
    code: "editor-code",
    quote: "editor-quote",
    placeholder: "editor-placeholder",
    paragraph: "editor-paragraph",
    heading: {
        h1: "editor-heading-h1",
        h2: "editor-heading-h2",
        h3: "editor-heading-h3",
        h4: "editor-heading-h4",
        h5: "editor-heading-h5",
        h6: "editor-heading-h6",
    },
    list: {
        listitem: "editor-list-item",
        listitemChecked: "editor-list-item-checked",
        listitemUnchecked: "editor-list-item-unchecked",
        nested: {
            listitem: "editor-nested-list-item",
        },
        ol: "editor-list-ol",
        ul: "editor-list-ul",
    },
    image: "editor-image",
    link: "editor-link",
    codeHighlight: {
        atrule: "editor-tokenAttr",
        attr: "editor-tokenAttr",
        boolean: "editor-tokenProperty",
        builtin: "editor-tokenSelector",
        cdata: "editor-tokenComment",
        char: "editor-tokenSelector",
        class: "editor-tokenFunction",
        "class-name": "editor-tokenFunction",
        comment: "editor-tokenComment",
        constant: "editor-tokenProperty",
        deleted: "editor-tokenProperty",
        doctype: "editor-tokenComment",
        entity: "editor-tokenOperator",
        function: "editor-tokenFunction",
        important: "editor-tokenVariable",
        inserted: "editor-tokenSelector",
        keyword: "editor-tokenAttr",
        namespace: "editor-tokenVariable",
        number: "editor-tokenProperty",
        operator: "editor-tokenOperator",
        prolog: "editor-tokenComment",
        property: "editor-tokenProperty",
        punctuation: "editor-tokenPunctuation",
        regex: "editor-tokenVariable",
        selector: "editor-tokenSelector",
        string: "editor-tokenSelector",
        symbol: "editor-tokenProperty",
        tag: "editor-tokenProperty",
        url: "editor-tokenOperator",
        variable: "editor-tokenVariable",
    },
    text: {
        code: "editor-text-code",
    },
    table: "editor-table",
    tableAddColumns: "editor-tableAddColumns",
    tableAddRows: "editor-tableAddRows",
    tableAlignment: {
        center: "editor-tableAlignmentCenter",
        right: "editor-tableAlignmentRight",
    },
    tableCell: "editor-tableCell",
    tableCellActionButton: "editor-tableCellActionButton",
    tableCellActionButtonContainer: "editor-tableCellActionButtonContainer",
    tableCellHeader: "editor-tableCellHeader",
    tableCellResizer: "editor-tableCellResizer",
    tableCellSelected: "editor-tableCellSelected",
    tableFrozenColumn: "editor-tableFrozenColumn",
    tableFrozenRow: "editor-tableFrozenRow",
    tableRowStriping: "editor-tableRowStriping",
    tableScrollableWrapper: "editor-tableScrollableWrapper",
    tableSelected: "editor-tableSelected",
    tableSelection: "editor-tableSelection",
}
